import React from 'react';
import './Pricing.scss';

const Pricing: React.FC = () => {
  const handlePurchaseDevice = () => {
    window.open('https://shadow-16723594.myshopify.com/products/shadow-tracker', '_blank');
  };

  const handlePurchaseSubscription = () => {
    window.open('https://shadow-16723594.myshopify.com/products/shadow-tracking-app-monthly', '_blank');
  };

  return (
    <section className="pricing" id="pricing">
      <div className="container">
        <h2>Protect Your Investment Today</h2>
        
        <div className="pricing-grid">
          <div className="price-card">
            <h3>Shadow Device</h3>
            <p className="price-subtitle">Hardware Device:</p>
            <ul>
              <li>Shadow Tracker device</li>
              <li>24 months battery life</li>
              <li>Installation guide</li>
              <li>1-year warranty</li>
              <li>Weatherproof design</li>
              <li>Stealth technology</li>
            </ul>
            <button 
              className="btn-primary purchase-btn device-only" 
              onClick={handlePurchaseDevice}
            >
              Buy Shadow Device
            </button>
          </div>

          <div className="price-card featured">
            <h3>App Subscription</h3>
            <p className="price-subtitle">Monthly Service:</p>
            <ul>
              <li>Real-time GPS tracking</li>
              <li>Unlimited data</li>
              <li>Mobile app access</li>
              <li>Movement alerts</li>
              <li>Location history</li>
              <li>24/7 monitoring</li>
              <li>Cancel anytime</li>
            </ul>
            <button 
              className="btn-primary purchase-btn app-btn" 
              onClick={handlePurchaseSubscription}
            >
              Start Subscription
            </button>
          </div>
        </div>
        
        <p className="service-note">*Both device and app subscription required for full functionality.</p>
      </div>
    </section>
  );
};

export default Pricing;
